export type BulkReviewAction = 'active' | 'isAutomatic' | 'managedBySystem';
export type BulkReviewStatus = 'will-update' | 'already-current';
export type BulkReviewActionArrow = 'update' | 'skip';

export interface ProductAdsBulkReviewRow {
  id: string;
  label: string;
  currentState: string;
  newState: string;
  rowAction: BulkReviewActionArrow;
  status: BulkReviewStatus;
  campaigns?: ProductAdsBulkReviewRow[];
}

export enum BulkReviewRowStatus {
  WILL_UPDATE = "will-update",
  ALREADY_CURRENT = "already-current",
}
export enum BulkReviewRowAction {
  UPDATE = "update",
  SKIP = "skip",
}

export enum PreviewRowStatus{
  WILL_CHANGE = "Will change",
  NO_CHANGE = "No change",
}

export interface BulkReviewModalConfig {
  action: BulkReviewAction;
  targetValue: boolean;
  isSelectAll: boolean;
  selectedItems?: any[];
  filter?: any;
  excludeIds?: (string | number)[];
  managedScope?: 'managed' | 'external' | 'all';
}

export interface ProductAdsBulkPreviewItem {
  itemKey: string;
  sku: string;
  currentValue: boolean;
  campaigns: Array<{
    adId: string;
    campaignName: string;
    currentValue: boolean;
  }>;
}

export interface BulkCountResponse {
  skuWillUpdate: number;
  skuAlreadyCurrent: number;
  adWillUpdate: number;
  adAlreadyCurrent: number;
}
